import { render, staticRenderFns } from "./PopTasks.vue?vue&type=template&id=c8cdd2b4&scoped=true&"
import script from "./PopTasks.vue?vue&type=script&lang=ts&"
export * from "./PopTasks.vue?vue&type=script&lang=ts&"
import style0 from "./PopTasks.vue?vue&type=style&index=0&id=c8cdd2b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8cdd2b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8cdd2b4')) {
      api.createRecord('c8cdd2b4', component.options)
    } else {
      api.reload('c8cdd2b4', component.options)
    }
    module.hot.accept("./PopTasks.vue?vue&type=template&id=c8cdd2b4&scoped=true&", function () {
      api.rerender('c8cdd2b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/PopTasks.vue"
export default component.exports